import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { EventStore } from '../service/event.store';
import { OnyxEvent } from '../models/event';
import { LogService } from '../../shared/log/log.service';
import { Observable } from 'rxjs/Observable';
import { MenuStore } from '../../menus/service/menu.store';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { EventSearchParametersStore } from '../service/event-search-parameters.store';

@Component({
  selector: 'pioneer-add-event',
  templateUrl: './add-event.component.html'
})
export class AddEventComponent implements OnInit {

  public eventForm: FormGroup;

  public onyxEvent: OnyxEvent;

  public isReadOnly: boolean;

  constructor(public router: Router,
              private formBuilder: FormBuilder,
              private eventStore: EventStore,
              private logService: LogService,
              private menuStore: MenuStore,
              private flashMessagesService: FlashMessagesService,
              private eventSearchParametersStore: EventSearchParametersStore) {
  }

  ngOnInit() {
    this.isReadOnly = false;

    this.onyxEvent = new OnyxEvent();
    this.eventForm = this.formBuilder.group({
      'event': this.formBuilder.group({})
    });
    this.menuStore.setPageTitle('EVENT.TITLE_ADD');
  }

  save(model: any): Observable<OnyxEvent> {

    model.event.eventAgency = model.eventAgency;
    model.event.eventClient = model.eventClient;
    model.event.eventProperty = model.eventProperty;

    const formModel = new OnyxEvent(model.event);
    const updatedRefCodes: Object = {};

    if (formModel.eventAgency) {
      updatedRefCodes[ 'agencyId' ] = formModel.eventAgency.agencyId;
    }

    if (formModel.eventClient) {
      updatedRefCodes[ 'clientReferenceNumber' ] = formModel.eventClient.clientReferenceNumber;
    }

    if (formModel.eventProperty) {
      formModel.eventProperty.eventReferenceNumber = model.event.groupCodeNumber;
      updatedRefCodes[ 'brand' ] = formModel.eventProperty.brand;
      updatedRefCodes[ 'chain' ] = formModel.eventProperty.chain;
      updatedRefCodes[ 'propertyId' ] = formModel.eventProperty.propertyId;
    }

    updatedRefCodes[ 'startDate' ] = new Date(formModel.startDate).toISOString();
    updatedRefCodes[ 'endDate' ] = new Date(formModel.endDate).toISOString();

    this.logService.debug(`updatedRefCodes ${updatedRefCodes}`);
    const updatedModel = formModel.merge(updatedRefCodes) as OnyxEvent;

    this.logService.debug(`updatedModel ${updatedModel}`);

    let returnedEvent = this.eventStore.addEvent(updatedModel);
    returnedEvent.subscribe(
      () => {
        this.returnToSearchList();
      },
      error => {
        this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT', error);
      });
    return returnedEvent;
  }

  returnToSearchList(): void {
    this.eventSearchParametersStore.updateUrl();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/add-event/add-event.component.ts